import { apiSlice } from "../apiSlice";
interface createCustomerRequest{
    userId:String;
    displayName:String;
    email:String;
    phoneNumber:String;
    photoUrl:String
}

interface createCustomerResponce{
    userId:String;
    customerId:String;
    displayName:String;
    email:String;
    phoneNumber:String;
    photoUrl:String
}
const API_BASE_DOMAIN = process.env.REACT_APP_API_BASE_DOMAIN_PRODUCTION;
export const CustomerCreateService =apiSlice.injectEndpoints({
    endpoints:(builder)=>({
        createCustomer :builder.mutation<createCustomerResponce,createCustomerRequest>({
            query:(data)=>({
                url:`https://customersitehttps-createcustomer-${API_BASE_DOMAIN}-uc.a.run.app`,
                method:"POST",
                body:data,
                headers:{
                    "Content-Type": "application/json"
                }
            })
        })
    })
})
export const {useCreateCustomerMutation} =CustomerCreateService;